import { GridActionsCellItem } from '@mui/x-data-grid';
import AutoCompleteDropdown from 'components/autocomplete/AutoCompleteDropdown';
import Button from 'components/common/Button';
import CardBody from 'components/common/CardBody';
import CardHeader from 'components/common/CardHeader';
import Column from 'components/common/Column';
import Container from 'components/common/Container';
import CustomCard from 'components/common/CustomCard';
import Row from 'components/common/Row';
import { displayNotification, generateOptionsFromData, sendAPIRequest } from 'helpers';
import DataTable from 'pages/components/DataTable';
import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate, useParams } from "react-router-dom";

const ExportUserMapping = () => {

    const [users, setUsers] = useState([]);
    const [experts, setExperts] = useState([]);
    const [pvsExperts, setPvsExperts] = useState([]);
    const [expertUser, setExpertUser] = useState({
        expert_id: '',
        user_id: ''
    });
    const [expertUsers, setExpertUsers] = useState([]);
    const [loading, setLoading] = useState(false);
    const { t } = useTranslation();

    useEffect(() => {
        getUsers();
        getCRMExperts();
        getExpertUsers();
        getPVSExperts();
    }, []);

    const getUsers = async () => {
        try {
            const ret = await sendAPIRequest(`/api/users/non-linked-users?role_id=21`);
            const res = await ret.json();
            if (res.success && res.status === 200) {
                setUsers(res.data);
            }
        } catch (err) {
            console.log({ err });
        }
    }

    const getCRMExperts = async () => {
        try {
            const ret = await sendAPIRequest(`/api/expert/all-experts?isCRM=true`);
            const res = await ret.json();
            if (res.success && res.status === 200) {
                setExperts(res.data);
            }
        } catch (err) {
            console.log({ err });
        }
    }
    const getPVSExperts = async () => {
        try {
            const ret = await sendAPIRequest(`/api/expert/all-experts?isCRM=false`);
            const res = await ret.json();
            if (res.success && res.status === 200) {
                setPvsExperts(res.data);
                console.log("data", res.data);
            }
        } catch (err) {
            console.log({ err });
        }
    }

    const linkExpert = async () => {
        try {
            if (!window.confirm('Are you sure you want to link?')) return;
            const ret = await sendAPIRequest(`/api/expert/link-expert`, 'POST', expertUser);
            const res = await ret.json();
            if (res.success && res.status === 201) {
                displayNotification('success', 'Expert linked successfully');
                setExpertUser({ expert_id: '', user_id: '' });
                await getExpertUsers();
                await getUsers()
            } else {
                displayNotification('error', 'Failed to link expert');
            }
        } catch (err) {
            displayNotification('error', 'Failed to link expert');
        }
    }

    const getExpertUsers = async () => {
        setLoading(true);
        try {
            const ret = await sendAPIRequest(`/api/expert/get-linked-experts`);
            const res = await ret.json();
            if (res.success && res.status === 200) {
                setExpertUsers(res.data);
            }
        } catch (err) {
            console.log({ err });
        }
        setLoading(false);
    }

    const deleteExpertUser = async (id) => {
        try {
            const ret = await sendAPIRequest(`/api/expert/linked-expert/${id}`, 'DELETE');
            const res = await ret.json();
            if (res.success && res.status === 200) {
                await getExpertUsers();
                await getUsers();
                await getCRMExperts();
                displayNotification('success', 'Expert unlinked successfully');
            }
        } catch (err) {
            displayNotification('error', 'Failed to unlink expert');
        }
    }

    const usersOptions = useMemo(() => {
        return generateOptionsFromData(users, {
            value: 'id',
            label: 'name'
        })
    }, [users]);

    const expertOptions = useMemo(() => {
        return generateOptionsFromData(experts, {
            value: 'id',
            label: 'expert_name'
        })
    }, [experts]);
    return (
        <Container>
            <div className="header card-woah border border-secondary d-flex px-4 py-2 shadow-sm w-100 my-2">
                <div className="card-title1 lh-1">
                    {t("-1", "Expert Mapping Status")}
                </div>
                <div className="header-right-items ms-auto d-flex align-items-center">
                    <Link to={"/portal/experts-management/"} className="ms-auto">
                        <button className="btn btn--primary fs-7 lh-1">
                            {" "}
                            <i className="fas fa-angle-left text-white" />
                            {t("32", "Back")}
                        </button>
                    </Link>
                </div>
            </div>
            {/* <CustomCard>
                <CardBody>
                    <Row>
                        <Column col={4}>
                            <AutoCompleteDropdown
                                required={true}
                                error={true}
                                label={"Users"}
                                multiple={false}
                                hasselectall={true}
                                options={usersOptions}
                                onChange={(event, value) => setExpertUser({ ...expertUser, user_id: value?.value })}
                                value={usersOptions.find(val => val.value == expertUser.user_id) ?? { value: '', label: '' }}
                            />
                        </Column>
                        <Column col={4}>
                            <AutoCompleteDropdown
                                required={true}
                                error={true}
                                label={"Experts"}
                                multiple={false}
                                hasselectall={true}
                                options={expertOptions}
                                onChange={(event, value) => setExpertUser({ ...expertUser, expert_id: value?.value })}
                                value={expertOptions.find(val => val.value == expertUser.expert_id) ?? { value: '', label: '' }}
                            />
                        </Column>
                        <Column col={4} className='d-flex justify-content-end'>
                            <Button
                                onClick={() => linkExpert()}
                            >
                                Link
                            </Button>
                        </Column>
                    </Row>
                </CardBody>
            </CustomCard> */}
            <CustomCard>
                <CardBody>
                    <RenderLinkedExperts users={users} PvsExperts={pvsExperts} CrmExperts={experts} experts={expertUsers} loader={loading} deleteData={deleteExpertUser} />
                </CardBody>
            </CustomCard>
        </Container>
    );
}

const RenderLinkedExperts = ({ experts, loader, deleteData, users, CrmExperts, PvsExperts }) => {

    const { t } = useTranslation();

    return (
        <>
            
            <div className="header card-woah border border-secondary d-flex px-4 py-2 shadow-sm w-100 my-2">
                <div className="card-title1 lh-1">
                    {t("-1", "Imported CRM Experts not linked with PVSIS Users ")}
                </div>
            </div>
            <DataTable
                getRowId={(row) => row.id}
                isLoading={loader}
                className="text-white bg-primary rounded-0"
                rows={CrmExperts}
                columns={[
                    {
                        field: "crm_id",
                        headerName: t("-1", "Crm Id"),
                        headerClassName: "text-white bg-primary rounded-0",
                        valueGetter: (params) => {
                            return params.row?.crm_id;
                        },
                        minWidth: 150,
                        flex: 1,
                    },
                    {
                        field: "expert_name",
                        headerName: t("-1", "Expert Name"),
                        headerClassName: "text-white bg-primary rounded-0",
                        valueGetter: (params) => {
                            return params.row?.expert_name;
                        },
                        minWidth: 150,
                        flex: 1,
                    },
                    {
                        field: "professional_email",
                        headerName: t("-1", "Official Email"),
                        headerClassName: "text-white bg-primary rounded-0",
                        valueGetter: (params) => {
                            return params.row?.person?.professional_email;
                        },
                        minWidth: 150,
                        flex: 1,
                    },
                    {
                        field: "personal_email",
                        headerName: t("-1", "Personal Email"),
                        headerClassName: "text-white bg-primary rounded-0",
                        valueGetter: (params) => {
                            return params.row?.person?.email;
                        },
                        minWidth: 150,
                        flex: 1,
                    },


                ]}
            />
            <div className="header card-woah border border-secondary d-flex px-4 py-2 shadow-sm w-100 my-2">
                <div className="card-title1 lh-1">
                    {t("-1", "Only PVSIS Experts ")}
                </div>
            </div>
            <DataTable
                getRowId={(row) => row.id}
                isLoading={false}
                className="text-white bg-primary rounded-0"
                rows={PvsExperts}
                columns={[
                    {
                        field: "expert_name",
                        headerName: t("-1", "Expert Name"),
                        headerClassName: "text-white bg-primary rounded-0",
                        valueGetter: (params) => {
                            return params.row?.expert_name;
                        },
                        minWidth: 150,
                        flex: 1,
                    },
                    {
                        field: "professional_email",
                        headerName: t("-1", "Official Email"),
                        headerClassName: "text-white bg-primary rounded-0",
                        valueGetter: (params) => {
                            return params.row?.person?.professional_email;
                        },
                        minWidth: 150,
                        flex: 1,
                    },
                    {
                        field: "personal_email",
                        headerName: t("-1", "Personal Email"),
                        headerClassName: "text-white bg-primary rounded-0",
                        valueGetter: (params) => {
                            return params.row?.person?.email;
                        },
                        minWidth: 150,
                        flex: 1,
                    },


                ]}
            />
            <div className="header card-woah border border-secondary d-flex px-4 py-2 shadow-sm w-100 my-2">
                <div className="card-title1 lh-1">
                    {t("-1", "PVSIS Users that are not linked with CRM-PVSIS Expert")}
                </div>
            </div>
            <DataTable
                getRowId={(row) => row.id}
                isLoading={loader}
                className="text-white bg-primary rounded-0"
                rows={users}
                columns={[
                    {
                        field: "name",
                        headerName: t("-1", "User Name"),
                        headerClassName: "text-white bg-primary rounded-0",
                        valueGetter: (params) => {
                            return params.row?.name;
                        },
                        minWidth: 150,
                        flex: 1,
                    },
                    {
                        field: "email",
                        headerName: t("-1", "User Email"),
                        headerClassName: "text-white bg-primary rounded-0",
                        valueGetter: (params) => {
                            return params.row?.email;
                        },
                        minWidth: 150,
                        flex: 1,
                    },
                    {
                        field: "user_type_name",
                        headerName: t("-1", "User Type Name"),
                        headerClassName: "text-white bg-primary rounded-0",
                        valueGetter: (params) => {
                            return params.row?.user_type_name;
                        },
                        minWidth: 150,
                        flex: 1,
                    },

                ]}
            />
        </>
    );
}

export default ExportUserMapping;